export interface APIBaseUrls {
  configstoreApiBaseUrl: string
  eventApiBaseUrl: string
  lfcApiBaseUrl: string
  scensumBaseUrl: string
}

export const getBaseUrls = (channelId: string): APIBaseUrls => ({
  configstoreApiBaseUrl: import.meta.env.VITE_CONFIGSTORE_API_BASE_URL,
  eventApiBaseUrl: import.meta.env.VITE_EVENT_API_BASE_URL,
  lfcApiBaseUrl: import.meta.env.VITE_LFC_API_BASE_URL,
  scensumBaseUrl:
    // if local .NET environment during development
    window.location.href.toLowerCase().includes('nopperoyal.public')
      ? `${window.location.protocol}//${window.location.hostname}/NoppeRoyal.Public`
      : import.meta.env[`VITE_SCENSUM_BASE_URL_CHANNEL_ID_${channelId}`],
})
